import { useEffect, useState } from 'react';
import api from '../api/client.js';
import { crc, fechaLegal, LEYENDA_IVA_INCLUIDO } from '../utils/format.js';
import { Icon } from './Icons.jsx';

const ESTADOS = {
  recibido: 'Recibido',
  diagnostico: 'Diagnostico',
  esperando_repuesto: 'Esperando repuesto',
  reparando: 'Reparando',
  listo: 'Listo',
  entregado: 'Entregado',
  no_reparable: 'No reparable',
};

const sumaExtras = (r) => Array.isArray(r.extras)
  ? r.extras.reduce((a, e) => a + Number(e.monto || 0), 0)
  : Number(r.total_extras || 0);
const totalReal = (r) => Number(r.total || 0) + sumaExtras(r);
const pendiente = (r) => Math.max(totalReal(r) - Number(r.abono || 0), 0);

/**
 * Tiquete de respaldo para el cliente. Es distinto del link de compartir:
 * se imprime y se lleva, con el QR del seguimiento publico.
 */
export default function TiqueteReparacion({ reparacion }) {
  const [qr, setQr] = useState(null);
  const [empresa, setEmpresa] = useState(null);

  useEffect(() => {
    if (!reparacion?.id) return;
    api.get(`/reparaciones/${reparacion.id}/qr`).then((r) => setQr(r.data.data.qr)).catch(() => {});
    api.get('/empresa').then((r) => setEmpresa(r.data.data)).catch(() => {});
  }, [reparacion?.id]);

  const imprimir = () => {
    const contenido = document.getElementById('ticket-reparacion-imprimible')?.innerHTML;
    if (!contenido) return;
    const w = window.open('', '_blank', 'width=380,height=640');
    w.document.write(`<html><head><title>Tiquete ${reparacion.numero}</title>
      <style>body{font-family:'Courier New',monospace;font-size:12px;padding:16px;color:#000}
      table{width:100%;border-collapse:collapse}td{padding:2px 0}
      .r{text-align:right}.c{text-align:center}.b{font-weight:bold}
      hr{border:none;border-top:1px dashed #999;margin:8px 0}img{max-width:140px}</style>
      </head><body>${contenido}</body></html>`);
    w.document.close();
    setTimeout(() => { w.print(); }, 300);
  };

  const pagado = totalReal(reparacion) > 0 && pendiente(reparacion) <= 0.001;

  return (
    <div>
      <div id="ticket-reparacion-imprimible" style={{
        fontFamily: "'Courier New', monospace", fontSize: 13, background: '#fff', color: '#000',
        padding: 18, borderRadius: 10, border: '1px solid var(--border)', maxWidth: 320, margin: '0 auto',
      }}>
        <div style={{ textAlign: 'center' }}>
          {empresa?.logo_url && (
            <img src={empresa.logo_url} alt=""
              style={{ maxWidth: 150, maxHeight: 70, objectFit: 'contain', marginBottom: 6 }} />
          )}
          <div style={{ fontWeight: 700, fontSize: 15 }}>{empresa?.nombre_comercial || 'Mi Negocio'}</div>
          {empresa?.razon_social && <div style={{ fontSize: 11 }}>{empresa.razon_social}</div>}
          {empresa?.identificacion && <div style={{ fontSize: 11 }}>Ced: {empresa.identificacion}</div>}
          {empresa?.telefono && <div style={{ fontSize: 11 }}>Tel: {empresa.telefono}</div>}
          <div style={{ fontSize: 11, marginTop: 4, fontWeight: 700 }}>TIQUETE DE REPARACION</div>
        </div>
        <hr style={{ border: 'none', borderTop: '1px dashed #999', margin: '8px 0' }} />
        <div style={{ fontSize: 11 }}>
          <div>Numero: {reparacion.numero}</div>
          <div>Fecha: {fechaLegal(reparacion.fecha_entrada)}</div>
          {(reparacion.cliente_nombre || reparacion.cliente?.nombre) && (
            <div>Cliente: {reparacion.cliente_nombre || reparacion.cliente?.nombre}</div>
          )}
          <div>Dispositivo: {reparacion.dispositivo}</div>
          {reparacion.descripcion && <div>Falla: {reparacion.descripcion}</div>}
          <div>Estado: {ESTADOS[reparacion.estado] || reparacion.estado}</div>
          <div>Pago: {pagado ? 'Pagado' : 'Pendiente'}</div>
        </div>
        {(totalReal(reparacion) > 0 || Number(reparacion.abono) > 0) && (
          <>
            <hr style={{ border: 'none', borderTop: '1px dashed #999', margin: '8px 0' }} />
            <table style={{ width: '100%' }}>
              <tbody>
                <tr><td>Total</td><td style={{ textAlign: 'right' }}>{crc(totalReal(reparacion))}</td></tr>
                {Number(reparacion.abono) > 0 && (
                  <tr><td>Abonado</td><td style={{ textAlign: 'right' }}>{crc(reparacion.abono)}</td></tr>
                )}
                <tr style={{ fontWeight: 700 }}>
                  <td>Pendiente</td>
                  <td style={{ textAlign: 'right' }}>{crc(pendiente(reparacion))}</td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        <div style={{ textAlign: 'center', fontSize: 10, marginTop: 8, fontStyle: 'italic' }}>
          {LEYENDA_IVA_INCLUIDO}
        </div>
        {qr && (
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <img src={qr} alt="QR seguimiento" style={{ maxWidth: 130 }} />
            <div style={{ fontSize: 10, marginTop: 4 }}>Escanea para consultar el estado</div>
          </div>
        )}
        <div style={{ textAlign: 'center', fontSize: 11, marginTop: 10 }}>
          Conserva este tiquete. Es tu respaldo.
        </div>
      </div>
      <div style={{ marginTop: 16 }}>
        <button className="btn btn-primary btn-block" onClick={imprimir}>
          <Icon.print /> Imprimir tiquete
        </button>
      </div>
    </div>
  );
}
